const pt = {
    enter_code: "ID de sessão",
    connect: "Entrar",
    check_your_internet_connection: "Verificar a sua conexão com a Internet.",
    network_error: "Erro na rede",
    server_error: "Erro no servidor",
    check_server_connection: "Erro no servidor interno",
    downtime: "Tempo de inatividade",
    server_is_currently_facing_downtime: "O servidor está inativo, em manutenção",
    show_what_you_see: "Vamos iniciar a Chamada de Vídeo",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "Confirmo que li e concordo com a Política de Privacidade.",
    privacy_policy: "Política de Privacidade",
    invalid_code: "ID de sessão inválida",
    code_should_be_of_nine_digits: "O ID da sessão deve ter 9 dígitos",
    blitzz: "Blitzz",
    please_enter_your_name: "Digitar o seu nome",
    maximum_value_is_30: "O nome deve ter menos de 30 caracteres.",
    please_enter_meeting_id: "Digitar o seu CÓDIGO",
    please_try_again: "Tentar novamente.",
    no_one_is_sharing_video: "Ninguém está compartilhando vídeo.",
    retry: "Tentar novamente",
    reconnect: "Reconectar",
    left_the_conversation: "saiu da conversa",
    enabled_the_audio: "ativou o áudio",
    disabled_the_audio: "desativou o áudio",
    enabled_the_video: "ativou o vídeo",
    disabled_the_video: "desativou o vídeo",
    failed_to_join_room: "Falha ao entrar na sala \\u0020",
    alert: "Alerta",
    override_video_sharing_message: "Gostaria de fechar a tela atual e compartilhar o seu vídeo?",
    override_screen_sharing_message: "Gostaria de fechar a tela atual e compartilhar a sua tela?",
    override_video_sharing_with_screen_capturing_message: "Gostaria de encerrar o vídeo e compartilhar a sua tela?",
    override_screen_sharing_with_video_sharing_message: "Gostaria de fechar a tela atual e compartilhar o seu vídeo?",
    yes: "SIM",
    cancel: "CANCELAR",
    joined_the_call: "entrou na chamada",
    waiting_for_other_members_to_join_the_call: "Aguardando que outros convidados se conectem na chamada",
    warning: "Aviso",
    camera_permission_disabled: "Acesso à câmera desativado.",
    microphone_permission_disabled: "Não foi possível acessar o microfone.",
    location_permission_disabled: "Acesso à localização desativado.",
    storage_permission_disabled: "Acesso ao armazenamento desativado",
    permission_error_message_camera: "Ativar a câmera nas configurações do dispositivo.",
    permission_error_message_microphone: "Ativar o microfone nas configurações do dispositivo.",
    permission_location_error_message: "Ativar a localização nas configurações do dispositivo.",
    permission_storage_error_message: "Ativar o armazenamento nas configurações do dispositivo.",
    give_permission: "Dar permissão",
    please_wait_for_five_seconds_to_take_screenshot: "Aguardar 5 segundos para tirar outra foto",
    please_wait_for: "Esperar por",
    seconds_to_take_screen_shot: "segundos para tirar outra foto.",
    second_to_take_screen_shot: "segundo para tirar outra foto.",
    invalid_information_received_from_server: "Informações inválidas recebidas do servidor.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet: "Erro ao compartilhar o vídeo, ninguém entrou na conversa ainda",
    successfully_uploaded: "Arquivo carregado com sucesso",
    disconnected: "Desconectado",
    call_ended_as_no_one_else_had_joined_the_call: "Desconectado porque ninguém se conectou.",
    application_update_required: "É necessário atualizar o aplicativo",
    update_required_message: "Parece que você tem uma versão antiga do aplicativo. Atualizar na loja de aplicativos.",
    update: "Atualizar",
    image_marking_started: "Marcação de imagem iniciada",
    image_marking_stopped: "Marcação de imagem parada",
    settings: "Definições",
    camera_permission_rationale: "Ativar o acesso à sua câmera.",
    microphone_permission_rationale: "Ativar o acesso ao seu microfone.",
    location_permission_rationale: "Ativar acesso à sua localização.",
    storage_permission_rationale: "Ativar o acesso ao seu armazenamento.",
    call_between_two_customers: "O agente não atendeu. Tentar novamente daqui a pouco.",
    media_projection_permission_needed_for_screen_sharing: "Ativar a projeção de mídia para compartilhar a tela.",
    poor_network_connection: "Aviso! A conexão de rede está ruim",
    you_are_the_only_person_in_the_call: "Você é a única pessoa na chamada",
    image_has_been_captured_and_started_uploading: "A imagem foi capturada e começou a ser carregada",
    version: "Versão",
    please_enter_the_code_provided_to_you: "Digitar o CÓDIGO que você recebeu.",
    start_screen_share: "Compartilhar a tela",
    stop_screen_share: "Parar de compartilhar",
    flip_camera: "Trocar a câmera",
    take_photo: "Tirar uma foto",
    flash_off: "Flash desligado",
    flash_on: "Flash ligado",
    start_markup: "Iniciar a marcação",
    stop_markup: "Parar a marcação",
    speaker_off: "Alto-falante desligado",
    speaker_on: "Alto-falante ligado",
    more: "Mais",
    close: "Fechar",
    video_off: "Vídeo desligado",
    video_on: "Vídeo ligado",
    start_video: "Iniciar o vídeo",
    stop_video: "Parar o vídeo",
    disconnect: "Desconectar",
    mute: "Mudo",
    muted: "Ativar o microfone",
    powered_by_blitzz: "Operado pela Blitzz",
    connecting_your_call: "Conectado. À espera de outros participantes.",
    connected: "Conectado",
    pin_is_of_nine_digit: "O código PIN deve ter 9 dígitos",
    preparing_image_for_markup: "Preparando a imagem para marcar…",
    clear_markup_confirmation: "Apagar as marcações de imagem de todos os usuários?",
    clear_markup: "Apagar a marcação",
    clear: "Apagar",
    close_markup: "Fechar a marcação",
    end_markup_confirmation: "Tem certeza que deseja fechar a marcação?",
    end: "Fim",
    agent_has_ended_markup_cannot_continue_without_agent: "O agente encerrou a marcação e não é possível continuar sem um agente.",
    joining_image_markup: "Carregando a imagem para a marcação...",
    cleared_markup: "Marcações de imagem apagadas para todos os usuários.",
    capturing_photo: "Capturando a foto ...",
    uploading: "Carregando",
    image: "imagem",
    image_ready_for_markup: "Imagem pronta para marcação.",
    override_video: "Isto irá parar o vídeo dos outros. Você quer continuar?",
    override_screen_share: "Isto irá parar o compartilhamento de tela dos outros. Você quer continuar?",
    started_screen_share: "Compartilhamento de tela iniciado.",
    stopped_screen_share: "Compartilhamento de tela parado.",
    clear_all: "Apagar tudo",
    start_new_call_popup: "Iniciar nova chamada com CÓDIGO",
    group_call_limit_reached: "Limite de chamada de grupo atingido",
    contact_admin_to_increase_participant_limit: "Aguarde até que qualquer outro participante se desconecte e tente novamente.",
    call_is_being_connected: "A ligação está sendo conectada. Tentar novamente mais tarde.",
    show_recording_for_training_purpose: "Esta sessão está sendo gravada.",
    you_are_sharing_the_screen: "Você está compartilhando a tela",
    location_colon: "Local:",
    date_colon: "Data:",
    image_for_markup_has_been_downloaded: "A imagem para marcação foi baixada",
    dismiss: "Dispensar",
    google_play_service_is_not_up_to_date: "Serviço Google Play desatualizado",
    rec: "gravando",
    you_are_offline: "Você está desconectado",
    markup: "Marcação",
    exit: "Saída",
    video_unsupported: "Vídeo não suportado",
    please_open_this_link_in_safari: "Abrir este link no Safari.",
    you_are_not_able_to_see_this_video: "Você não pode ver este vídeo.",
    only_number_Allowed: "Digitar somente números.",
    permission_warning: "Aviso de permissão",
    unable_to_join_call_please_try_after_sometime: "Erro ao conectar na chamada. Tentar daqui a pouco.",
    share_live_video: "Quer compartilhar o seu vídeo ao vivo?",
    share_your_screen: "Quer compartilhar a sua tela?",
    unable_access_flash: "Erro ao acessar o flash do celular.",
    camera_unavailable_try_again: "A câmera não está disponível. Tentar novamente.",
    unable_download_image_tomarkup: "Não foi possível baixar a imagem do servidor. Tente novamente.",
    try_again: "Tentar novamente",
    markup_screen_appear_shortly: "A tela de marcação será apresentada em breve ...",
    confirm: "Confirmar",
    start: "Começar",
    could_not_find_endpoint: "O servidor de conexão não foi encontrado.",
    please_wait: "Aguardar…",
    done: "Pronto",
    ok: "OK",
    please_try_again_with_valid_agent_id: "Tentar novamente com um ID de agente válido.",
    meeting_code_not_associated_with_agent: "A ID da sessão não está associada a esta ID do agente.",
    powered_by: "Operado pela",
    failure: "Erro",
    code: "ID de sessão",
    start_new_call_question: "Iniciar uma nova chamada?",
    stop_sharing: "Parar de compartilhar",
    reconnecting_call: "Reconectando na chamada ...",
    unable_to_access_mircrophone_or_camera: "Não foi possível acessar o  seu microfone ou a sua câmera.",
    be_sure_to_allow_access_in_browser: "Ativar o acesso nas configurações do seu navegador.",
    make_sure_you_have_microphone_camera_attached: "Confirmar que a câmera e o microfone estão conectados.",
    location_blocked_by_user: "Localização bloqueada pelo cliente",
    user_has_joined_the_call: "Usuário entrou na chamada",
    are_you_sure_you_want_to_close_window: "Tem certeza que deseja fechar esta janela?",
    reset_guide: "Guia para Reiniciar",
    open_in_google_maps: "Abrir no Google Maps",
    location_image_upload_failed: "Erro para carregar a imagem de localização",
    uploading_image: "Carregando imagem",
    upload_failed: "Falha ao carregar",
    markup_is_in_progress: "A marcação está em andamento ...",
    select_language: "Selecionar o idioma",
    checking_for_extension: "Verificando a extensão ...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Para compartilhar a tela no modo anônimo, você precisa iniciar a navegação anônima na extensão Blitzz - Screen Share do seu navegador.",
    click_on: "Clicar em",
    customize_and_control_menu: "Personalizar e controlar o menu",
    more_tools: "Mais ferramentas",
    extensions: "Extensões",
    click_on_detail: "Clicar no detalhe (Blitzz)",
    allow_in_incognito: "Permitir em modo anônimo.",
    screen_share: "Compartilhamento de tela",
    stop_share: "Parar de compartilhar",
    save: "Salvar",
    cancel_initcap: "Cancelar",
    yes_initcap: "Sim",
    message_title: "Mensagem",
    device_not_compatible: "Este dispositivo não é compatível.",
    please_download_our_app: "Baixar o nosso aplicativo para continuar.",
    download_app: "Baixar o aplicativo",
    this_browser_is_not_supported: "Este navegador não é suportado, no momento.",
    open_in_chrome_or_install_mobile_app:
        "Copie e cole este link na versão mais recente do Google Chrome ou instale nosso aplicativo móvel e tente novamente.",
    open_in_safari_or_install_mobile_app:
        "Copie e cole este link na versão mais recente do navegador Safari ou instale nosso aplicativo móvel e tente novamente.",
    open_in_chrome_and_try_again: "Abrir este link na versão mais recente do Google Chrome e tentar novamente.",
    okay_initcap: "OK",
    would_you_like_to_install_app_or_continue_browser:
        "Gostaria de instalar o nosso aplicativo para participar da chamada ou avançar com o navegador?",
    continue_initcap: "Continuar",
    webview_limited_support_message: "Para uma melhor experiência, abra o arquivo no navegador Chrome ou no seu navegador padrão.",
    continue_anyway: "Continue mesmo assim",
    open_in_browser: "Abrir no navegador",
    link_copied_open_in_browser: "Link copiado! Se o navegador não abrir, cole o link no Chrome.",
    add_blitzz_extension_to_screen_share: "Adicionar extensão Blitzz ao compartilhamento de tela",
    add_to_chrome_and_confirm: "Adicionar ao Chrome e confirmar",
    add_extension: "Adicionar a extensão",
    permission_error_message_camera_browser: "Ativar a câmera a partir das configurações do navegador.",
    camera_not_found: "Câmera não encontrada",
    enable_camera_and_reconnect_call: "Você precisa ativar sua câmera, recarregar a página e reconectar a chamada.",
    permission_error_message_microphone_browser: "Ativar o microfone nas configurações do navegador.",
    permission_error_message_location_browser: "Ative a localização nas configurações do navegador.",
    microphone_not_found: "Microfone não encontrado",
    enable_microphone_and_reconnect_call: "Você precisa ativar o seu microfone, recarregar a página e reconectar a chamada.",
    download_failed: "Falha ao baixar",
    continue_markup: "Continuar a marcação",
    save_and_exit: "Salvar e sair da marcação",
    exit_markup: "Sair da marcação",
    you_are_recording_the_conversation: "Você está gravando a chamada",
    make_sure_participant_know_they_are_being_recorded: "Confirmar que todos sabem que a chamada está sendo gravada.",
    you_can_download_recordings_later: "Você pode baixar o arquivo gravado depois.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Para compartilhar a tela, você precisa iniciar a sessão ShowMe e digitar o código que recebeu.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "Limite de chamadas de grupo alcançado. Entrar em contato com o seu administrador para aumentar o limite ou esperar alguém sair da sessão.",
    other_user_trying_share_screen_Video: "Outro usuário está tentando compartilhar tela ou vídeo",
    call_has_ended: "A chamada terminou.",
    would_you_like_to_save_image: "Gostaria de salvar a imagem?",
    audio_unsupported: "áudio não suportado",
    please_install_our_app_to_continue: "Por favor, instale nosso aplicativo para continuar.",
    unable_to_play_remote_audio: "Não é possível reproduzir áudio remoto.",
    unable_to_playback_audio: "Não é possível a reprodução de áudio.",
    unable_to_play_video: "Não é possível reproduzir vídeo.",
    unable_to_playback_video: "Não é possível a reprodução de vídeo.",
    okay_cap: "OK",
    pre_call_test: "Teste de pré-chamada",
    language: "Língua",
    reset: "Redefinir",
    zoom_in: "Mais zoom",
    zoom_out: "Menos zoom",
    headset: "Fone de ouvido",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "O ponteiro ao vivo foi ativado. Você pode mover o ponteiro arrastando",
    speaker: "Alto Falante",
    live_pointer_disabled_message: "Ponteiro ao vivo parado",
    pointer: "Ponteiro",
    network_quality: "Qualidade de Rede",
    participant: "Participante",
    you: "(Você)",
    reconnecting: "Reconectando",
    very_bad: "Muito ruim",
    bad: "Ruim",
    poor: "Pobre",
    good: "Boa",
    excellent: "Excelente",
    loc: "Loc",
    expand: "Expandir",
    collapse: "Minimizar",
    network: "Rede",
    ocr_inprogress: "Processando a captura do texto...",
    select_area_extract_text: "Selecione a área para extrair o texto",
    text_copied: "Texto copiado",
    extract_text_from_image: "Extraindo o texto da imagem ...",
    not_extract_text_from_image: "Não foi possível extrair o texto da imagem.",
    try_again_clear_image_or_reselect_region: "Tente novamente com uma imagem boa ou selecione a região de extração do texto de novo",
    error: "Erro",
    occured_while_receiving_doc: "ocorreu enquanto recebia o documento.",
    return_to_video: "Retornar ao vídeo",
    save_entire_image: "Salvar inteiro",
    save_cropped_image: "Salvar cortada",
    text_copied_to_clipboard: "Clique para copiar",
    extract_text: "Extrair o texto",
    stop_pointer: "Parar o ponteiro",
    do_not_rotate_the_phone_live_pointer_message:
        "Não gire o telefone enquanto o ponteiro ao vivo estiver ativado, para uma melhor experiência de visualização.",
    got_it_btn: "Funcionou!",
    speed_test: "Teste de Velocidade",
    duration: "Duração",
    preparing_image_for_OCR: "Preparando a imagem para extrair o texto…",
    agent_extract_text_from_image: "Aguarde, o agente está extraindo o texto da imagem.",
    unable_download_image_to_ocr: "Tente novamente, não foi possível baixar a imagem para processamento.",
    selected_area_is_small: "A área selecionada é muito pequena",
    please_select_large_area: "Selecione uma área grande na imagem ",
    zoom_level: "Nível de zoom",
    do_not_rotate_the_phone_markup_message:
        "Para uma melhor experiência de visualização, não gire o dispositivo enquanto a marcação estiver ativada.",
    capturing: "Capturando ...",
    upload_completed: "Upload concluído",
    network_quality_not_available: "Qualidade de rede não disponível",
    not_able_to_see_your_stream: "não poderá ver seu stream.",
    device_not_supported: "Dispositivo não suportado.",
    video_settings_need_to_be_configured_by_admin_web:
        "As configurações de vídeo precisam ser definidas pelo seu administrador para suportar este dispositivo. Entre em contato com o administrador da empresa ou envie um email para",
    contact: "Contacto",
    video_paused_by_agent: "Vídeo pausado pelo agente",
    not_shared: "Nao compartilhado",
    network_type: "Tipo de rede",
    image_thumb_caption: "Imagem:",
    saved_images: "Imagens salvas",
    update_your_browser_to_share_your_screen: "Atualize seu navegador para a versão mais recente para compartilhar sua tela",
    try_these_option_to_have_better_experience: "Experimente uma dessas opções para uma melhor experiência.",
    some_features_are_not_supported_in_this_browser: "Alguns recursos não são suportados neste navegador.",
    unsupported_browser: "Navegador não suportado",
    permission_message_for_screenshare:
        "As permissões para acessar a área da tela foram negadas ou a instância atual do navegador não possui permissões para acessar o compartilhamento de tela.",
    go_to_system_preferences: "Ir para Preferências do sistema",
    security_privacy: "segurança e privacidade",
    select_privacy_tab: "Selecione a guia Privacidade",
    screen_recording: "Gravação de tela",
    select_your_browser: "Selecione seu navegador",
    use_chrome_to_share_your_screen: "Use o navegador Chrome ou Firefox para compartilhar sua tela",
    there_was_an_error_trying_to_share_your_video: "Ocorreu um erro ao tentar compartilhar seu vídeo.",
    please_stop_video_and_start_video_again_to_resume: "Pare o vídeo e inicie o vídeo novamente para retomar.",
    decline: "Declínio",
    agree: "Aceita",
    click_the_padlock: "Clique no cadeado",
    to_the_left_of_a_web_page_address: "à esquerda da barra de endereço.",
    clear_blocked_permission_for_share_the_screen: "Limpe todas as permissões de compartilhamento de tela bloqueadas na seção de permissões.",
    tips_colon: "Dicas:",
    your_internet_connection_is_unstable: "Sua conexão à Internet é instável",
    participants_connection_unstable: "A conexão de internet do participante <participantNum> é instável",
    enter_text_here: "Insira o texto aqui",
    text: "Texto",
    rect: "Rect",
    draw: "Desenhar",
    try_our_mobile_app: "Abrir na aplicação",
    still_facing_issue_connect_mobile_app: "Se você ainda estiver enfrentando um problema, conecte-se usando nosso aplicativo móvel.",
    open_in_app: "Abrir na aplicação",
    enable_microphone_from_browser_settings: "Ative o microfone nas configurações do navegador.",
    enable_camera_from_browser_settings: "Ative a câmera nas configurações do navegador.",
    unable_to_access_microphone: "Não foi possível acessar o microfone",
    participants_title: "Participantes",
    bookmarks_title: "Favoritos",
    search_or_add_new_bookmark: "Pesquise ou adicione novo marcador",
    create_new_bookmark: "Criar novo marcador",
    press_enter_or_click_on_create_new_bookmark: "Pressione Enter ou clique em Criar novo marcador para adicionar um novo marcador",
    tap_retry_to_load: "Toque em Repetir para carregar",
    bookmark_saved_with_image: "Marcador salvo com imagem.",
    bookmark_saved: "Marcador salvo.",
    bookmark_added: "Marcador adicionado.",
    failed_to_bookmark_please_try_again: "Falha ao marcar como favorito. Por favor, tente novamente.",
    special_characters_are_not_allowed: "Caracteres especiais não são permitidos.",
    home_screen: "Tela inicial",
    privacy_policy_popup_text_description:
        "Entendo e concordo em usar voluntariamente minha câmera para compartilhar uma visão do meu ambiente e resolver os problemas técnicos que estou tendo. Entendo que nenhuma gravação será feita ou armazenada. Posso desativar o recurso de compartilhamento a qualquer momento. Não apontarei a câmera para áreas, indivíduos ou itens cuja imagem não desejo compartilhar. Também confirmo que li e concordo com a Política de Privacidade.",
    audio_issue_ios: "Problema de áudio?",
    toggle_mic_icon_guest_msg: "Alterne o ícone vermelho de microfone / câmera acima ou use o áudio da chamada telefônica. (PSTN)",
    toggle_mic_icon_agent_msg:
        "Solicite ao usuário do iOS que alterne o ícone vermelho do microfone / câmera acima ou use o áudio da chamada telefônica. (PSTN)",
    audio_ios_msg_read_more: "Consulte Mais informação",
    error_occured_in_processing_the_request: "Ocorreu um erro ao processar a solicitação. Por favor, tente novamente.",
    markup_ocr_upload_timeout: "Demorando mais que o normal.",
    cancel_markup: "Cancelar marcação",
    markup_cancelled: "Marcação cancelada",
    cancel_ocr: "Cancelar Extrair texto",
    ocr_cancelled: "Extrair texto cancelado",
    click_here: "Clique aqui",
    to_return_to_video_and_try_again: "para retornar ao vídeo e tente novamente.",
    test_connection: "Conexão de teste",
    markup_exit: "parou a marcação",
    ocr_exit: "parado Extrair texto",
    camera: "Câmera",
    camera_blocked: "Câmera bloqueada",
    microphone: "Microfone",
    microphone_blocked: "Microfone bloqueado",
    speakers: "caixas de som",
    speakers_blocked: "Alto-falantes bloqueados",
    grant_permission: "Conceder permissão",
    play_test_sound: "Reproduzir som de teste",
    call_settings: "Configurações de chamada",
    allow_access_to_camera: "Permitir acesso à sua câmera.",
    allow_access_to_mic: "Permitir acesso ao seu microfone.",
    default_label: "Padrão",
    do_not_rotate_the_phone_OCR_message:
        "Para uma melhor experiência de visualização, não gire o dispositivo enquanto a opção Extrair texto estiver ativada.",
    browser_not_supported: "Navegador não suportado",
    your_browser_not_support_video: "Seu navegador não suporta videochamadas.",
    open_link_in_google_samsung_browser: "Copie e cole este link na versão mais recente do navegador Google Chrome ou Samsung.",
    open_link_in_safari_browser: "Copie e cole este link na versão mais recente do navegador Safari.",
    copy_link: "Link de cópia",
    copy_code: "Copiar código",
    session_code_copy: "ID da sessão copiada para a área de transferência.",
    meeting_code_lable: "Código da reunião",
    add_participant_lable: "Adicionar participante",
    send_this_link_to_guest: "Envie este link para o convidado",
    send_an_email: "enviar um email",
    or_label: "ou",
    remote_mic_cam_error: "O microfone / câmera do participante remoto está com erro.",
    device_not_supported_or_permi_block: "O dispositivo deles não é suportado ou eles têm permissões bloqueadas.",
    remote_participant: "Participante remoto",
    microphone_unmuted: "Microfone sem som",
    microphone_muted: "Microfone sem som",
    camera_on: "Câmera Ligada",
    camera_off: "Câmera desligada",
    error_label: "erro",
    cannot_start_video: "Não é possível iniciar o vídeo",
    failed_to_start_video_camera: "Falha ao iniciar a câmera de vídeo.",
    please_select_another_camera_from_call_settings: "Selecione outra câmera de vídeo em Configurações de chamada.",
    please_select_another_video_camera: "Por favor, selecione outra câmera de vídeo.",
    chat: "Bate-papo",
    chat_info:
        "As mensagens de bate-papo são visíveis para todos na chamada. O histórico de bate-papo desaparecerá permanentemente quando você desconectar, por design.",
    chat_input_placeholder: "Digite uma mensagem",
    participant_connected: "<participantCount> participantes conectados",
    click_to_share_invite: "Clique para compartilhar o convite",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "Lanterna remota não suportada no dispositivo convidado ou não pronta",
    pin_a_video_tile_above_to_use_this_feature: "Fixar um bloco de vídeo acima para usar esse recurso",
    pin_video_for_all_participants: "Fixar vídeo a todos os participantes",
    return_to_gallery_view: "Voltar à visualização da galeria",
    override_own_screen_share: "Seu compartilhamento de tela será interrompido. Você quer continuar?",
    override_own_video: "O seu vídeo será parado. Você quer continuar?",
    blur: "Borrão",
    mask_lable: "mascarar",
    view_text: "Visão",
    arrow: "Seta",
    recording_stopped: "Gravação parada",
    error_recording_please_try_again: "Erro ao gravar, tente novamente",
    error_recording_wait_or_disconnect_call:
        "Erro ao gravar. Aguarde até que o host pare de gravar ou você pode se desconectar e entrar novamente mais tarde.",
    wait_for_recording: "Aguarde enquanto iniciamos a gravação ...",
    max_participant_limit_for_recording:
        "Máx. limite de participantes atingido durante a gravação. Aguarde até que o host pare de gravar ou você pode se desconectar e entrar novamente mais tarde.",
    error_recording_all_participants: "Erro ao registrar todos os participantes.",
    please_stop_and_restart_recording: "Pare e reinicie a gravação.",
    some_participants_will_not_be_recorded: "Alguns participantes não serão gravados.",
    participant_limit_reached: "Limite de participantes atingido.",
    your_account_has_4_participant_limit_while_recording: "Sua conta tem limite de 4 participantes durante a gravação.",
    disconnect_call: "Desligar chamada",
    record_title: "Registro",
    stop_recording_btn: "Pare de gravar",
    back_to: "De volta a",
    cam_per_denied_msg: "Um de seus participantes pode ter bloqueado o acesso à câmera em seu dispositivo. Para orientá-los, consulte",
    mic_per_denied_msg: "Um de seus participantes pode ter bloqueado o acesso ao microfone em seu dispositivo. Para orientá-los, consulte",
    cam_mic_per_denied_msg:
        "Um de seus participantes pode ter bloqueado o acesso à câmera e ao microfone em seu dispositivo. Para orientá-los, consulte",
    per_denied_common_msg: "para obter dicas rápidas para redefinir as permissões do navegador.",
    your_camera_block: "Sua câmera está bloqueada",
    your_microphone_block: "Seu microfone está bloqueado",
    your_location_block: "Seu local está bloqueado",
    we_cannot_access_your_camera: "Não podemos acessar sua câmera.",
    we_cannot_access_your_microphone: "Não podemos acessar seu microfone.",
    we_cannot_access_your_location: "Não podemos acessar sua localização.",
    go_to_browser_settings: "Para dar acesso, acesse as configurações do seu navegador e clique aqui para recarregar a página.",
    still_facing_issue: "Ainda está enfrentando problemas?",
    try_the: "Tente o",
    mobile_app: "aplicativo móvel",
    view_help_article: "Veja o artigo de ajuda",
    enable_or_attach_camera_and_reconnect_call: "Você precisa habilitar ou conectar a câmera, recarregar a página e reconectar a chamada.",
    enable_or_attach_microphone_and_reconnect_call: "Você precisa habilitar ou conectar o microfone, recarregar a página e reconectar a chamada.",
    start_rec_label: "Iniciar Gravação",
    stop_rec_label: "Parar Gravação",
    start_recording_tooltip_label: "Comece a gravar",
    click_here_label: "Clique aqui",
    cam_per_denied_title: "Câmera remota do participante bloqueada",
    mic_per_denied_title: "Microfone de participante remoto bloqueado",
    cam_mic_per_denied_title: "Câmera e microfone do participante remoto bloqueados",
    these_instructions: "essas instruções",
    Whisper_on: "Whisper On",
    Whisper_off: "Whisper Off",
    enable_whisper_tooltip_label: "Ativar sussurro para falar com o anfitrião",
    host_can_hear_you_now: "O anfitrião pode ouvir você agora",
    mediate_lable: "Mediar",
    join_call_as_participant: "Junte-se à chamada como participante",
    observer_lable: "Observador",
    silent_observer_connect_alert_popup: "Conectado como observador. Seu microfone e câmera estão mudos.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Clique em "Mediar" se quiser participar.',
    guest_lable: "Convidado",
    Silent_observer_lable: "Observador silencioso",
    invite_participant_tooltip_lable:
        "O microfone e a câmera serão silenciados para o observador silencioso e não serão visíveis para os participantes convidados.",
    send_link_silent_observer: "Envie este link para o observador silencioso.",
    join_as_mediator_title: "Junte-se como mediador?",
    join_as_mediator_popup_description:
        "Tem certeza de que deseja entrar na chamada como participante? Clique em Confirmar abaixo e, em seguida, clique em Conectar na próxima tela para ingressar como participante (mediador).",
    from_participant: "Do participante",
    download_key: "Baixar",
    download_not_supported_text: "O download não é compatível com seu dispositivo.",
    undo: "Desfazer",
    redo: "Refazer",
    color_label: "Cor",
    overall_experience: "Experiência geral?",
    leave_comment: "Deixe um comentário (opcional)",
    sent: "Enviei",
    send: "Mandar",
    view_unavailable: "Ver indisponível",
    whisper_label: "Sussurro",
    thanks: "Obrigado!",
    stop_recording_tooltip_label: "Retorne ao modo galeria para parar a gravação.",
    save_image: "Salvar imagem",
    screenshare_mweb_text: "O compartilhamento de tela do seu dispositivo requer um aplicativo. Conecte esta sessão a partir do aplicativo móvel.",
    disconnect_and_launchapp_btn: "Desconectar e iniciar o aplicativo",
    device_battery_low: "Bateria do dispositivo fraca",
    batteryinfo_tooltip: "Informações da bateria do dispositivo",
    notes_lable: "Notas",
    new_note_lable: "Nova nota",
    only_visible_to_you: "Visível apenas para você",
    empty_note: "Nota vazia",
    title_lable: "Título",
    delete_lable: "Excluir",
    delete_Note: "Excluir nota",
    want_delete_this_note: "Tem certeza de que deseja excluir esta anotação?",
    failed_delete_note: "Falha ao excluir nota.",
    note_deleted_successfully: "Nota excluída",
    failed_edit_note: "Falha ao editar nota.",
    note_edited_successfully: "Nota atualizada",
    failed_add_note: "Falha ao adicionar nota.",
    note_added_successfully: "Nota adicionada",
    screenshare_mweb_title: "Download do aplicativo necessário",
    screenshare_mweb_desc1: "O compartilhamento de tela do seu dispositivo requer um aplicativo.",
    screenshare_mweb_desc2: "para baixar o aplicativo.",
    upcoming_event: "Próximos eventos",
    scheduled_to_start_in: "Programado para começar em",
    please_wait_for_the_host_to_start_this_event: "Aguarde até que o anfitrião inicie este evento e tente novamente.",
    image_deleted: "Imagem excluída",
    failed_to_delete_image: "Falha ao excluir imagem",
    are_you_sure_you_want_to_delete_image: "Tem certeza de que deseja excluir esta imagem permanentemente?",
    delete_image_title: "Apagar imagem",
    location_image_thumb_caption: "Imagem de localização",
    schedule_to_start_in_a_few_seconds: "Programado para começar em alguns segundos.",
    edit_label: "Editar",
    scan_code_lable: "Código de leitura",
    scan_code_result: "Resultado da leitura do código",
    extract_text_result: "Extrair resultado de texto",
    scan_code_result_not_found: "Não foi possível ler o código QR / código de barras da imagem. Tente novamente com uma imagem nítida.",
    host_features_will_not_be_available_when_using_app: "Os recursos do host não estarão disponíveis ao usar o aplicativo.",
    note_colon: "Nota:",
    leave_lable: "Sair",
    are_you_sure_you_want_to_leave_this_call: "Tem certeza de que deseja sair desta chamada?",
    supported_browser_versions: "Versões de navegador compatíveis.",
    see: "Vejo",
    has_sent_you_link_for_video_conference: "Clicar no link enviado pela <company_name>, para voce entrar na chamada de video.",
    join_the_session: "Junte-se à sessão",
    other: "De outros",
    share_invitation_with_others: "Compartilhe o convite da sessão com outras pessoas",
    copy_invitation: "Copiar o convite da sessão",
    copy_invitation_desc: "Copie o texto do convite com a hora programada e envie-o manualmente",
    copied: "Copiado!",
    copy_session_code: "Copiar ID da Sessão",
    copy_link_to_share: "Copiar link para compartilhar",
    reference: "Referência",
    session_invitation_copied: "Convite de sessão copiado para a área de transferência.",
    guest_url_copy: "URL de convidado copiado para a área de transferência.",
    observer_url_copied: "URL do observador copiado para a área de transferência.",
    sms_sent_label: "SMS enviado!",
    email_sent_label: "Email enviado!",
    invite_sent_successfully: "Convite enviado com sucesso",
    sms_label: "SMS",
    copy: "cópia de",
    email: "O email",
    enter_valid_email: "Digite o endereço de e-mail válido.",
    limit_exceeded: "Limite excedido",
    enter_email_send: "Digite o e-mail para enviar um convite",
    send_invitaion_lable: "Enviar convite",
    enter_mobile_number_lable: "Digite o número do celular",
    enter_valid_mobile: "Insira um número de celular válido.",
    new_email_address: "Endereço de email",
    mobile_number: "Número de celular",
    video_quality: "Qualidade de vídeo",
    low_bandwidth: "Baixa largura de banda",
    adaptive: "Adaptativo",
    high_quality: "Alta qualidade",
    wait_for_the_call_to_start: "Espere a chamada começar",
    call_disconnected: "Chamada desconectada",
    dont_show_this_again: "Não mostre isso de novo",
    invite_participant_lable: "Convidar Participante",
    saved_label: "Salvou!",
    show_stream: "mostrar",
    hide_stream: "Esconder",
    camera_permission_required_title: "Requer permissão de câmera",
    camera_permission_required_disc1:
        "Para compartilhar o vídeo ao vivo, ative a permissão da câmera nas configurações do seu navegador e, em seguida,",
    reload_page_disc: "para recarregar a página.",
    location_permission_required_title: "Permissão de localização necessária",
    microphone_permission_required_title: "Permissão de microfone necessária",
    confirmation_lable: "Posso confirmar que li e concordo com os",
    live_location: "Live Location",
    no_one_shared_location: "Ninguém compartilhou seu local",
    it_was_great_lable: "Foi ótimo",
    not_so_great_lable: "Não tão bom",
    link_copied: "Link copiado",
    microphone_publication_description: "Microfone não encontrado ou pode estar sendo usado por outro aplicativo.",
    please_close_all_other_application: "Feche todos os outros aplicativos que podem estar usando microfone e tente novamente.",
    app_to_share_your_device_screen: "Continue esta chamada no aplicativo para compartilhar a tela do seu dispositivo",
    launch_app: "Lançamento do Aplicativo",
    screen_share_requires_app: "O compartilhamento de tela requer um aplicativo.",
    only_takes_few_seconds: "Isso leva apenas alguns segundos.",
    download_app_from_app_store_and_then_return_page: "Baixe o aplicativo na App Store e volte a esta página.",
    click_to_download_app: "Clique para baixar o aplicativo",
    go_to_Step_2: "Se você já baixou o aplicativo, vá para a Etapa 2",
    next_lable: "Próximo",
    rejoin_the_call_in_app: "Volte à chamada no aplicativo",
    step2_screen_share_description:
        "Depois de baixar o aplicativo, você pode voltar a esta chamada no aplicativo e selecionar “Compartilhamento de tela” para compartilhar a tela do seu celular.",
    disconnect_the_call_in_browser: "Isso desconectará a chamada no navegador",
    back_btn_lable: "Voltar",
    rejoin_call_in_app: "Reingressar na chamada no aplicativo",
    step_one: "Passo 1",
    step_two: "Passo 2",
    beta_release_tag_des1: "Este recurso está atualmente em versão Beta.",
    email_support_feedback: "Envie um e-mail para support@blitzz.co para compartilhar seus comentários.",
    would_you_like_to_exit_markup: "Você gostaria de sair da marcação?",
    current_position: "Posição atual",
    start_point: "Ponto de partida",
    live_captions: "Legendas ao vivo",
    starting_label: "Iniciando...",
    live_captions_started: "As legendas ao vivo foram iniciadas.",
    spoken_language_is_set_to_english: "O idioma falado está definido como inglês.",
    click_to_open_more_information: "Clique para abrir mais informações",
    open_in_safari_chrome_or_install_mobile_app:
        "Copie e cole este link na versão mais recente do Safari ou do navegador Google Chrome ou instale nosso aplicativo móvel e tente novamente.",
    continue_without_name: "Continuar sem nome",
    enter_your_name: "Digite seu nome",
    ignore: "Ignorar",
    screen_share_info:
        "Para evitar um espelho infinito, não compartilhe a tela inteira ou a janela do navegador. Compartilhe apenas uma guia ou uma janela diferente.",
    screen_share_to_everyone: "Você está compartilhando a tela com todos",
    stop_share_screen: "Parar de compartilhar tela",
    unable_to_start_the_video_please_download_the_app_to_continue: "Não foi possível iniciar o vídeo, faça o download do aplicativo para continuar.",
    upload: "Carregar",
    from_device: "Do dispositivo",
    from_camera: "Da câmera",
    upload_failed_files: "Carregar arquivos com falha",
    uploaded_max_file: "Você carregou o número máximo de arquivos permitidos.",
    upload_files: "Fazer upload de arquivos",
    upload_limit_reached: "Limite de upload atingido",
    drop_for_upload_or_select: "Solte aqui para fazer upload ou selecione",
    upload_20_file: "Carregue até 20 arquivos por vez.",
    max_size_20MB: "Máx. tamanho do arquivo <fileSize> MB.",
    cancel_upload: "Cancelar carregamento",
    cancel_upload_alert: "Cancelar carregamento?",
    file_details_deleted: "Quaisquer detalhes adicionados aos seus arquivos serão excluídos.",
    uploaded_files: "Arquivos enviados",
    capture_image: "Capturar imagem",
    participant_uploading_file_msg: "Aguarde enquanto o outro participante carrega os arquivos.",
    previous: "Anterior",
    max_file_count: "Você pode carregar o máximo de arquivos <fileCount> por vez.",
    removed_more_than_20MB_file: "Arquivos com mais de <fileSize> MB de tamanho são removidos.",
    uploading_files: "Carregando arquivo(s)",
    upload_failed_file_count: "Falha no upload: os arquivos <numberOfFailedFiles> não foram carregados.",
    add_caption: "Adicionar legenda...",
    uploaded_files_of_a_maximum: "Arquivo(s) <successCount> (s), de um máximo de <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Você selecionou o número máximo de arquivos permitidos.",
    upload_max_count: "Carregue o(s) arquivo(s) <remainingCount> máximo.",
    image_upload_msg: "Aguarde enquanto as imagens estão sendo carregadas",
    finished_uploading: "Envio concluído",
    upload_files_msg: "Fazer upload de arquivos",
    uploading_dots: "Enviando…",
    loading_image_counter: "Carregando imagem <counter> de <totalCount>",
    closing_tab: "Aba de fechamento",
    close_tab: "Aba fechada",
    return_to_home_screen: "Voltando à tela inicial",
    session_code_expire_msg: "Este link foi fechado",
    view_call_logs: "Ver registros de chamadas",
    measurements: "Medidas",
    copy_all: "Copiar tudo",
    measure: "A medida",
    view_supported_device: "Ver dispositivos compatíveis",
    device_not_support_google_play_service: "O dispositivo participante não é compatível com o Google Play Service, necessário para medições em 3D",
    device_not_compatible_for_measurement: "Dispositivo não compatível para medição",
    device_required_update_google_play_service: "O dispositivo participante requer a atualização do Google Play Service para iniciar a Medição 3D.",
    device_required_google_play_service: "O dispositivo participante requer a instalação do Google Play Service para iniciar a Medição 3D",
    app_required_update_for_measurement: "Atualização de aplicativo de suporte necessária para avaliação",
    app_required_for_measurement: "Aplicativo de suporte necessário para medição",
    preparing_ar_measurement: "Preparando a visualização para medição...",
    measurement_copied_msg: "Medidas copiadas para a área de transferência",
    ready_for_measurement: "Pronto para medição",
    move_device_to_start: "Mova o dispositivo para iniciar",
    tacking_not_available: "O rastreamento não está disponível",
    camera_use_bu_another_app: "A câmera está sendo usada por outro app",
    more_light_required: "Mais luz necessária",
    move_further_away: "Afaste-se mais",
    slow_down: "Desacelerar",
    measurement_cancelled: "Medição cancelada",
    app_required: "Este recurso requer o download do aplicativo. <learnmore>",
    learn_more: "Saber mais",
    ar_measurement_description_step2:
        'Depois de baixar o aplicativo, você pode voltar a participar desta chamada no aplicativo e selecionar "Medir" para iniciar a medição de RA',
    ar_measurement_description_step1: "O recurso de medição de realidade aumentada permite medir objetos em 3D e requer um download do aplicativo",
    app_to_support_ar_measurement: "Continue esta chamada no aplicativo para oferecer suporte à medição de RA",
    find_surface_to_measure: "Encontre uma superfície próxima para medir",
    measurement_toast_note_to_guide_user: "Nota: As medidas são aproximadas.",
    measurement_toast_msg_to_guide_user:
        "Para obter melhores resultados, use Medir em objetos bem definidos localizados de 0,5 a 3 metros (2 a 10 pés) do seu telefone.",
    having_audio_issue: "Tendo um problema de áudio?",
    remote_participant_voice_not_coming_description:
        "Parece que você está enfrentando dificuldades para ouvir a voz de outro participante ou enfrentando algum tipo de problema de áudio no momento.",
    workaround_action_for_remote_audio_not_coming: "<click_here> para aplicar uma solução rápida.",
    click_here_for_audio_label: "Clique aqui",
    measurement_copyall_msg: "Medida(s) copiada(s) para a área de transferência",
    armarkup_cancelled: "Marcação AR cancelada",
    device_not_support_google_play_service_for_markup:
        "O dispositivo do participante não oferece suporte ao Google Play Service, necessário para marcação 3D",
    device_required_update_google_play_service_for_markup:
        "O dispositivo do participante requer a atualização do Google Play Service para iniciar a marcação 3D.",
    device_required_google_play_service_for_markup:
        "O dispositivo do participante requer a instalação do Google Play Service para iniciar a marcação 3D",
    device_not_compatible_for_AR_Markup: "Dispositivo não compatível com AR Markup",
    app_required_update_for_AR_Markup: "Atualização de aplicativo de suporte necessária para marcação AR",
    app_required_for_AR_Markup: "Aplicativo de suporte necessário para marcação AR",
    preparing_view_for_ar_markup: "Preparando visualização para marcação AR...",
    AR_Markup_Lable: "Marcação AR",
    armarkup_toast_msg_to_guide_user:
        "Para obter melhores resultados, use Marcação em objetos bem definidos localizados de 0,5 a 3 metros (2 a 10 pés) de seu telefone.",
    ar_live_streaming_ready_to_markup: "AR live streaming pronto para marcação.",
    ar_markups_cleared_for_all_users: "As marcações AR foram liberadas para todos os usuários.",
    ar_live_streaming_marking_stopped: "Marcação de transmissão ao vivo AR interrompida",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "O agente encerrou a marcação AR. Não é possível continuar a marcação AR sem agente",
    ar_markup_cancelled: "Marcação AR cancelada",
    ready_for_ar_markup: "Pronto para marcação AR",
    max_ar_arrow_limit_toast_message: "Limite de setas atingido, por favor use limpar tudo para adicionar mais.",
    video_paused: "vídeo pausado",
    discard_label: "Descartar",
    discard_image_label: "Descartar Imagem",
    save_image_label: "Salvar imagem",
    go_room_call_limit_reached: "Limite de chamadas para a sala atingido",
    circle: "Círculo",
    arrow_with_text: "Seta com texto",
    add_shadow_and_stroke: "Adicionar sombra e traçado",
    font_label: "Fonte:",
    file_type_not_supported: "Tipo de arquivo(s) não suportado(s)",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Clique no botão Nova nota abaixo para começar a fazer anotações",
    remote_user_stream_interrupted: "Fluxo de usuário remoto interrompido",
    audio_disabled_by_admin: "Áudio desabilitado pelo Admin",
    audio_disabled: "Áudio desativado",
    dont_show_again: "Não mostrar novamente",
    whatsapp_sent_label: "Convite do WhatsApp enviado!",
    whatsapp_label: "Whatsapp",
    having_an_issue_with_joining_the_call: "Está com problemas para participar da chamada?",
    to_perform_network_check: "para executar verificação de rede",
    you_were_removed_from_the_call_by_the_host: "Você foi removido da chamada pelo anfitrião",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now:
        "Você foi removido da chamada pelo anfitrião e não pode entrar novamente agora.",
    host_removed_you_from_the_call: "O anfitrião removeu você da chamada.",
    unable_to_join_the_call: "Não é possível participar da chamada",
    host_muted_your_microphone: "O anfitrião silenciou seu microfone.",
    unmute_your_microphone: "Ative o som do seu microfone",
    host_invites_you_to_speak_unmute_your_microphone_when_ready:
        "O anfitrião convida você a falar. Desative o som do seu microfone quando estiver pronto.",
    got_it: "Entendi",
    unmute_mic: "Ativar microfone",
    host_turned_off_your_camera: "O anfitrião desligou sua câmera.",
    turn_your_camera_on: "Ligue sua câmera",
    host_invites_you_to_turn_your_camera_on: "O anfitrião convida você a ligar sua câmera.",
    turn_camera_on: "Ligue a câmera",
    start_sharing_your_screen: "Comece a compartilhar sua tela",
    host_invites_you_to_share_your_screen: "O anfitrião convida você para compartilhar sua tela.",
    share_screen: "Compartilhar tela",
    remove_all: "Remover tudo",
    remove: "Remover",
    end_call: "Terminar chamada",
    removing_all_participants_will_end_the_call: "Remover todos os participantes encerrará a chamada.",
    are_you_sure_you_want_to_remove_from_this_call: "Tem certeza de que deseja remover <participantName> desta chamada?",
    block_from_rejoining_this_call: "Bloquear <participantName> de voltar a participar desta chamada",
    turn_all_mics_off: "Desligue todos os microfones",
    turn_all_cams_off: "Desligue todas as câmeras",
    ask_to_turn_mic_on: "Peça para ligar o microfone",
    turn_mic_off: "Desligar o microfone",
    turn_cam_off: "Desligue a câmera",
    ask_to_turn_cam_on: "Peça para ligar a câmera",
    ask_to_share_screen: "Peça para compartilhar a tela",
    having_a_video_problem: "Está com problemas de vídeo?",
    ios_play_pause_modal_body_text:
        "Tente desativar o modo de economia de energia do seu celular para corrigir isso ou clique no botão Reproduzir abaixo para reproduzir o vídeo por enquanto.",
    play_video: "Reproduzir vídeo",
    camera_request_sent: "Solicitação de câmera enviada.",
    waiting_for_host_approval: "Aguardando aprovação do host.",
    microphone_request_sent: "Solicitação de microfone enviada.",
    camera_request_denied: "Solicitação de câmera negada.",
    click_the_camera_icon_if_you_need_to_request_again: "Clique no ícone da câmera se precisar solicitar novamente.",
    microphone_request_denied: "Solicitação de microfone negada.",
    click_the_mic_icon_if_you_need_to_request_again: "Clique no ícone do microfone se precisar solicitar novamente.",
    deny: "Negar",
    allow: "Permitir",
    user_wants_to_start_their_camera: "<ParticipantName> quer iniciar seu <micOrCam>",
    error_in_processing_live_caption_please_retry: "Erro no processamento da legenda ao vivo, tente novamente.",
    virtual_background: "Fundo Virtual",
    upload_image: "Carregar imagem",
    remove_image: "Remover imagem",
    remove_background_image: "Remover imagem de fundo",
    are_you_sure_you_want_to_remove_background_image: "Tem certeza de que deseja remover a imagem de fundo?",
    unsupported_file_format: "Formato de arquivo não suportado.",
    the_maximum_file_size_supported_is_in_mb: "O tamanho máximo de arquivo suportado é <size> MB.",
    no_effect: "Sem efeito",
    blur_background: "Desfocar fundo",
    default_image: "Imagem padrão",
    virtual_background_not_supported: "Fundo virtual não suportado.",
    remove_from_call: "Remover da chamada",
    enable_offline_mode: "Habilitar modo offline",
    offline_mode_enabled: "Modo offline habilitado",
    your_images_will_upload_when_you_reconnect: "Suas imagens serão carregadas quando você se reconectar.",
    please_keep_this_screen_open: "Por favor, mantenha esta tela aberta.",
    max_images_upload: "Máx <count> imagens",
    remaining_image_count_label: "<remainingCount> de <totalCount> Imagens",
    selected_images: "Imagens Selecionadas",
    offline_uploads_are_not_supported_in_private_mode: "Uploads offline não são suportados no Modo Privado.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Mude para uma aba normal do navegador para usar este recurso.",
    guest_is_using_a_private_browser_window: "O convidado está usando uma janela privada do navegador.",
    offline_upload_mode_is_not_supported_in_this_case: "O modo de upload offline não é suportado neste caso.",
    some_images_failed_to_upload_due_to_a_network_error: "Algumas imagens não foram carregadas devido a um erro de rede.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Fechar este modal descartará todas as imagens que você selecionou durante o modo offline.",
    live_captions_stopped: "Legendas ao vivo interrompidas.",
    translate: "Traduzir",
    auto_translate: "Tradução automática",
    your_language: "Seu idioma",
    translation_info_text: "As mensagens de outros participantes serão traduzidas automaticamente para o idioma selecionado.",
    translating: "Traduzindo...",
    show_original: "Mostrar original",
    show_translation: "Mostrar tradução",
    translated: "Traduzido",
    send_message_in: "Enviar mensagem em",
    audio_translation: "Traduzir",
    audio_translation_setup: "Tradução de Áudio",
    they_speak: "Eles falam",
    i_want_to_hear: "Eu quero ouvir",
    start_translation: "Iniciar Tradução",
    stop_translation: "Parar Tradução",
    starting_translation: "Iniciando tradução...",
    translation_started: "Tradução de áudio iniciada.",
    translation_stopped: "Tradução de áudio parada.",
    translation_error: "Erro de tradução. Por favor, tente novamente.",
    translation_active: "Tradução ativa",
    voice_type: "Voz",
    voice_female: "Feminina",
    voice_male: "Masculina",
};

export default pt;
